
import request from '@/utils/request'
// 领取优惠券列表
export function center(params) {
    return request({
        url: '/v1/coupon/center',
        method: 'get',
        params,
    })
}

// 领取优惠券
export function receive(data) {
    return request({
        url: '/v1/coupon/receive',
        method: 'post',
        data,
        showLoading: true
    })
}
// 用户优惠券列表
export function userCouponList(params) {
    return request({
        url: '/v1/coupon/userCouponList',
        method: 'get',
        params,
    })
}
// 用户优惠券详情
export function userCoupondetail(params) {
    return request({
        url: '/v1/coupon/userCoupondetail',
        method: 'get',
        params,
    })
}
// 赠送商品
export function sendGoods(data) {
    return request({
        url: '/v1/coupon/sendGoods',
        method: 'post',
        data,
        showLoading: true
    })
}